/**
 * All credit goes to Chance (Reach UI), Haz (Reakit), Chakra UI and (fluentui)
 * for creating the base type definitions
 */
import React from "react";

// This gets the HTML Element version of the JSX element (e.g. "button" becomes HTMLButtonElement)

var forwardRef = component => {
  return /*#__PURE__*/React.forwardRef(component);
};
export default forwardRef;